import React, { createContext, useContext, useState } from 'react';

const ShovellerSignupContext = createContext();

export const useShovellerSignupContext = () => useContext(ShovellerSignupContext);

export const ShovellerSignupProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    userRole: "shoveller",
    userName: '',
    firstName:'',
    lastName:'',
    phone: '',
    email: '',
    latitude: '',
    longitude: '',
    referredBy: '',
    password: '',
    servicesProvide: [],
    image: null,
    // New fields for address details
    address: '',
    city: '',
    province: '',
    country: '',
    postalCode: '',
    notifyForPosts: true
  });

  const [selectedServices, setSelectedServices] = useState([]);
  const [error, setError] = useState(""); // New state for error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (image) => {
    setFormData((prevData) => ({
      ...prevData,
      image,
    }));
  };

  const handleNotifyChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      notifyForPosts: !prevData.notifyForPosts,
    }));
  }

  return (
    <ShovellerSignupContext.Provider
      value={{
        formData,
        handleChange,
        setFormData,
        error,
        setError, // Provide error setter
        selectedServices,
        setSelectedServices,
        handleImageChange,
        handleNotifyChange
      }}
    >
      {children}
    </ShovellerSignupContext.Provider>
  );
};
